// using module.exports here so gatsby-config can read it
module.exports = {
  // TODO: Replace next line with your own public API key
  builderAPIKey: process.env.BUILDER_API_KEY,
  appUrl: process.env.REACT_APP_URL,
};
